
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/middlemen/pay",
      function () {
        return require("private-next-pages/middlemen/pay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/middlemen/pay"])
      });
    }
  